import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8cdfe26a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8cdfe26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdfe26a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RestaurantCard: require('/workspace/components/RestaurantCard.vue').default})
